import { DELIVERY_MENU_PLATFORMS, platformDisplayName, platformHasPickupChannel } from './deliveryPlatform'
// 플랫폼 목록·포장 축 술어의 정본은 플랫폼 표(`deliveryPlatform.js`)다 — 기존 import 경로를 위해 다시 내보낸다
export { DELIVERY_MENU_PLATFORMS, platformHasPickupChannel }
import { httpErrorMessage as deliveryMenuErrorMessage, httpStatusOf } from '../plugins/http/policy.js'
export { httpErrorMessage as deliveryMenuErrorMessage } from '../plugins/http/policy.js'
// 화면 문구·채널 어휘의 정본은 **의존성 없는** 모듈이다 — 이유는 그 파일 머리주석 참조.
// 여기서 그대로 재수출하므로 기존 호출부의 import 경로는 바뀌지 않는다.
// ★★ **목록을 손으로 유지하지 않는다** (규약 §16.230). 종전에는 「import 해서 그대로 다시
// export」 블록이 있었고, 이름이 하나 늘 때마다 **두 곳**을 고쳐야 했다 — 그리고 **세 번 틀렸다**
// (`catalogSharedNote` · `hasAnyOptionAxisOpen` · `optionOrdernAmbiguousNote`). 빠뜨리면 빌드는
// **경고만 내고 통과**하므로 CI 도 배포도 막지 못하고, 그 화면을 여는 순간 런타임에서 죽는다.
//
// 이름 충돌은 빌드가 잡는다 — 수동 목록이 주는 유일한 이점(무엇이 재수출되는지 한눈에 보임)보다
// 목록이 틀릴 자리를 없애는 쪽이 낫다.
export * from './deliveryMenuNotes'
// ★★ `DELIVERY_MENU_CHANNEL` 은 **여기서 쓰는데 여기 없다** — 정본은 `deliveryMenuNotes.js` 다.
// 이 import 가 빠져 있던 동안 [channelPriceRows] 가 정의되지 않은 자유 변수를 읽어 던졌고,
// 그 computed 를 쓰는 「배달앱 가격」 패널이 **통째로 안 그려졌다**(cypress 10건 · 08-25~08-28).
// 빌드는 통과한다 — 자유 변수는 번들 시점에 아무도 세지 않는다(§16.230 이 named import 에 대해
// 적어 둔 것과 같은 침묵이고, 축만 다르다).
import {
  DELIVERY_MENU_CHANNEL,
  ITEM_STATUS,
  LINK_STATE,
  OPTION_ITEM_AMBIGUOUS_NOTE,
  OPTION_MAPPING_TEXT,
  OPTION_MATCH,
  OPTION_MATCH_AMBIGUOUS_TEXT,
  OPTION_MATCH_MISSING_TEXT,
  IMPORT_REQUIRED_TEXT,
  OPTION_MATCH_UNREAD_TEXT,
  OPTION_OUTBOUND_NEEDS_IMPORT,
  OPTION_USE_YN_FIELD,
  OPTION_USE_YN_LABEL,
  PICKUP_PRICE_FIELD,
  PLATFORM_REJECTED_ACTION,
  POS_SOLDOUT_TEXT,
  STALE_LINK_HIDDEN_NOTE,
  USE_YN_FIELD,
  deliveryFieldNote,
  deliveryOrdernOnlyItemsNote,
} from './deliveryMenuNotes'
import { util } from '@/mixins/utilMixin'

/**
 * 배달앱 메뉴 동기화 — 어드민 화면 공용 어휘·문구 (SSOT). 대상 플랫폼은 `deliveryPlatform.js` 표가 정한다.
 *
 * 서버는 `status`·`resultCode` **어휘만** 내리고 사용자 문구는 프론트가 만든다
 * (규약 §9.1·§9.2·§16.57). 그 매핑을 여기 한 곳에만 둔다 — 화면마다 적으면 같은 status 의
 * 문구가 갈리고, 그것이 서버 응답에 한글을 넣지 않기로 한 이유를 무너뜨린다.
 *
 * 계약 SSOT: `ordern-workspace/docs/delivery-menu/delivery-menu-sync-contract.md` (§16 이 본문보다 우선)
 * 화면 가이드: `ordern-workspace/docs/delivery-menu/delivery-menu-sync-admin-guide.md`
 */

export const DELIVERY_MENU_API = '/api/delivery-menu'

/**
 * 품절 쓰기 — 메뉴·옵션 둘 다 `SharedMenuService` 한 곳이고 전파는 `DeliveryMenuSyncListener` 이벤트다(표면 무관).
 * 옵션 화면(`SMenuOptGroupForStoreView`)과 POS 임베드 화면이 같은 경로를 부른다 — 리터럴을 두 곳에 적지 않는다.
 */
export const MENU_BOARD_STOP_SELLING_API = '/api/menu-board/stop-selling'
export const MENU_BOARD_OPT_STOP_SELLING_API = '/api/menu-board/opt-stop-selling'

/**
 * **메뉴판 쓰기의 세션 액션** — 서버 리소스 `POST /api/menu-board/**` 하나에 걸린 액션이라 그 아래 쓰기 전부(메뉴판 등록·
 * 장착·실현과 위 품절 쓰기)가 이것 하나로 열린다(07-08 샵인샵 SQL: 점주·사업장 관리자·내부 관리자, 09-23 SQL 034: 관리점·
 * 운영사). 수정(`PUT`)·삭제(`DELETE`)는 따로 `MenuBoardUp`·`MenuBoardDel` 이다. 없는 세션(예: `custMngTemp`)의 호출은 보안
 * 계층 403 이고 이 앱의 403 은 로그아웃이라, 그 쓰기를 부르는 화면(메뉴판 편집·사업장·대행 「옵션 관리」의 품절 열)은 이것을
 * 먼저 묻는다.
 */
export const MENU_BOARD_WRITE_ACTION = 'MenuBoardAdd'

/**
 * 일괄 확정 한 요청의 상한 — 서버 `DeliveryMenuAdminService.BULK_MATERIALIZE_MAX` 와 **같은 값**이다
 * (§16.183). 초과하면 서버가 요청 전체를 400 으로 거절하므로 아무것도 등록되지 않는다.
 *
 * 두 곳에 같은 수가 있는 것은 계약이지 중복이 아니다 — 서버는 그것을 **강제**하고 화면은 보내기
 * 전에 **말해 준다**. 서버 값을 바꾸면 이 값도 같은 커밋에서 바꾼다.
 */
export const BULK_MATERIALIZE_MAX = 200

/**
 * 일괄 확정 응답 여럿을 **한 결과**로 합친다 (§16.183) — 순수 함수.
 *
 * 화면이 선택을 두 갈래(관측 카테고리가 있는 링크 / 없는 링크)로 나눠 보내기 때문에 응답도 둘이
 * 온다. 사장님에게는 한 번의 조작이었으므로 결과도 하나여야 한다 — 두 개의 대화상자를 띄우면
 * "무엇이 등록됐고 무엇이 남았는가"를 사람이 더해야 한다.
 *
 * 합계를 서버 값에서 다시 세지 않고 `results` 에서 파생한다 — 두 축이 어긋날 자리를 만들지 않는다.
 */
/**
 * **이 링크들의 카테고리를 화면 목록에서 고를 수 있는가** (§16.178·§16.186).
 *
 * `GET /category/store` 에는 매장 축이 없어 **세션 매장 카테고리만** 내려온다. 그래서 다른 매장
 * (형제 매장) 링크에 그 목록의 `categoryCd` 를 실어 보내면 서버가 링크마다
 * `이 링크는 N 매장의 것이라 다른 매장 카테고리에 넣을 수 없습니다` 400 을 낸다 — 사장님은
 * 화면이 고르게 해 준 것을 골랐는데 전량이 남는다. 이름 갈래는 서버가 **그 링크의 매장에서**
 * 카테고리를 확보하므로 안전하다.
 *
 * 단건(링크 하나)과 일괄(링크 여럿)이 **같은 술어**를 쓴다 — 한쪽에만 게이트가 있으면 §16.183 이
 * 겨냥한 바로 그 장면(새로 연 형제 매장 온보딩)에서 그 게이트 없는 쪽이 전량 실패한다.
 */
/**
 * **이 행을 `새 메뉴로 등록` 할 수 있는가** — ③ 목록의 두 갈래를 가르는 술어 (§16.257).
 *
 * ③ 은 이제 `ORPHAN` 과 `AMBIGUOUS` 를 함께 싣는다. 둘의 해소는 **같지 않다**:
 *
 * - `smenuCd == null` — 붙일 오더엔 메뉴가 아직 없다. `메뉴 연결`·`새 메뉴로 등록` 둘 다 열린다.
 * - `smenuCd != null` — 상대는 정해졌고 **확정만 남았다**. 창설은 서버가 409 로 거절한다
 *   (`이미 오더엔 메뉴에 연결된 링크입니다`) — 누를 수 있게 두면 사장님이 눌러 보고 나서야 안다.
 *
 * 단건 버튼과 일괄 체크박스가 **같은 술어**를 쓴다 — 한쪽에만 게이트가 있으면 일괄이 그 행을
 * 담아 전량 409 를 받는다([canPickStoreCategories] 가 같은 이유로 두 자리를 함께 지킨다).
 */
export function canMaterializeRow(row) {
  return !!row && row.smenuCd == null
}

export function canPickStoreCategories(links, sessionStoreCd) {
  if (sessionStoreCd == null) return false
  const list = Array.isArray(links) ? links : [links]
  if (list.length === 0) return false
  return list.every((link) => link && Number(link.storeCd) === Number(sessionStoreCd))
}

/**
 * 요청 하나가 **통째로** 거절됐을 때 — 그 요청의 링크 전부를 같은 사유의 건별 실패로 편다.
 *
 * §16.183 의 어휘에서 실패는 오류가 아니라 **남은 할 일**이고, 그것을 담는 자리는 `results[]`
 * 하나다. 요청 단위 실패만 그 모델 밖에 두면 두 가지를 함께 잃는다: 먼저 성공한 요청의 건별
 * 결과가 화면에 닿지 못하고(그 링크들은 **이미 서버에 반영됐다**), 무엇이 남았는지도 셀 수 없다.
 * 카테고리 갈래(§16.178)로 요청이 둘로 나뉘므로 이것은 예외가 아니라 정상 경로다.
 */
export function rejectedRequestResults(linkIds, message, status) {
  return {
    // **400 만 "한 건도 안 들어갔다"를 뜻한다** (§16.183). 그 밖(타임아웃·5xx·네트워크)은 서버가
    // 건별로 커밋해 두고 응답만 못 준 것일 수 있다 — 서버는 linkId 마다 트랜잭션을 따로 닫는다.
    // 그때 화면이 전량을 "남았습니다"로 세면 이미 만들어진 메뉴를 사장님이 다시 만들려 든다.
    uncertain: status !== 400,
    results: (linkIds || []).map((linkId) => ({ linkId, ok: false, message })),
  }
}

export function mergeBulkMaterializeResults(responses) {
  const results = (responses || []).flatMap((r) => (r && r.results) || [])
  return {
    succeeded: results.filter((r) => r.ok).length,
    failed: results.filter((r) => !r.ok).length,
    /** 응답을 못 받은 요청이 하나라도 있었는가 — 그러면 아래 숫자는 **하한**이다 (§16.183) */
    uncertain: (responses || []).some((r) => r && r.uncertain === true),
    results,
  }
}
export const DELIVERY_CAPABILITY_API = '/api/admin/delivery-capabilities'

// 이 계약이 다루는 플랫폼(`DELIVERY_MENU_PLATFORMS`)은 플랫폼 표가 파생한다 — 위 재수출이 그 이름을 그대로 내보낸다.

/**
 * **플랫폼마다 한 칸을 그리는 격자의 열** (`:style` 로 쓴다) — 칸 수는 동기화 대상 플랫폼 수(플랫폼 표 파생)다.
 *
 * 서버는 메뉴·옵션마다 그 플랫폼마다 한 칸을 내리므로(링크가 없으면 `linkState: null` 칸), 칸 수를 CSS 에 고정해
 * 두면 플랫폼이 늘 때(§16.307 땡겨요) 넘친 칸이 둘째 줄로 내려간다. POS 품절 화면의 목록 행과 진행 드로어가 함께 쓴다.
 */
export const DELIVERY_PLATFORM_CELLS_STYLE = Object.freeze({
  gridTemplateColumns: `repeat(${DELIVERY_MENU_PLATFORMS.length}, minmax(0, 1fr))`,
})

// `LINK_STATE`·`ITEM_STATUS` 어휘는 `deliveryMenuNotes.js`(의존성 없는 모듈)로 옮겼다 — POS 임베드 화면의 판정
// (`posDeliverySoldout.js`)이 앱 번들 밖 단위 테스트에서 같은 어휘를 읽기 위해서다. 위 `export *` 가 그대로 내보낸다.

/** 드리프트 판정 어휘 (`DeliveryMenuDriftView.state`) */
export const DRIFT_STATE = {
  IN_SYNC: 'IN_SYNC',
  DRIFT: 'DRIFT',
  UNKNOWN: 'UNKNOWN',
}

/** §11.2 해결 어휘 */
export const DRIFT_RESOLUTION = {
  PUSH_ORDERN: 'PUSH_ORDERN',
  ACCEPT_PLATFORM: 'ACCEPT_PLATFORM',
}

/** 화면 권한 게이트 — `sa_actions` 값 (SQL §3 등록분) */
export const DELIVERY_MENU_ACTIONS = {
  VIEW: 'DeliveryMenuView',
  BIND: 'DeliveryMenuBind',
  POLICY_UP: 'DeliveryMenuPolicyUp',
  CAPABILITY_ADD: 'DeliveryCapabilityAdd',
}

/** chip 톤 → Element UI `el-tag` type. 톤 어휘는 가이드 §1 표와 같다 */
const TONE_TAG_TYPE = {
  중립: 'info',
  대기: 'info',
  진행: '',
  성공: 'success',
  경고: 'warning',
  실패: 'danger',
}

/**
 * status → 문구·톤 (가이드 §1 매핑표).
 *
 * `SUPERSEDED` 만 문구가 `resultCode` 에 의존한다 — status 만 보고 문구를 만들면 최신 편집으로
 * 대체된 작업이 "반영 대상 없음" 으로 읽힌다.
 */
const STATUS_CHIP = {
  [ITEM_STATUS.NOT_LINKED]: { text: '미연동', tone: '중립' },
  [ITEM_STATUS.DISABLED]: { text: '동기화 제외', tone: '중립' },
  [ITEM_STATUS.WAITING_EXECUTOR]: { text: 'POS 연결 대기', tone: '대기' },
  [ITEM_STATUS.WAITING_AUTH]: { text: '플랫폼 재인증 필요', tone: '경고' },
  [ITEM_STATUS.QUEUED]: { text: '반영 중', tone: '진행' },
  [ITEM_STATUS.CLAIMED]: { text: '반영 중', tone: '진행' },
  [ITEM_STATUS.EXECUTING]: { text: '반영 중', tone: '진행' },
  [ITEM_STATUS.SUCCEEDED]: { text: '반영 완료', tone: '성공' },
  [ITEM_STATUS.FAILED]: { text: '반영 실패', tone: '실패' },
  [ITEM_STATUS.OUTCOME_UNKNOWN]: { text: '반영 여부 확인 필요', tone: '경고' },
  [ITEM_STATUS.BLOCKED_LINK]: { text: '메뉴 연결 확인 필요', tone: '경고', resolve: 'ORPHAN' },
  [ITEM_STATUS.UNSUPPORTED]: { text: '해당 변경 미지원', tone: '중립' },
  [ITEM_STATUS.DRIFT_BLOCKED]: { text: '플랫폼 변경 확인 필요', tone: '경고', resolve: 'DRIFT' },
  [ITEM_STATUS.EXPIRED]: { text: '미반영 (기한 경과)', tone: '실패' },
}

const SUPERSEDED_CHIP = {
  SUPERSEDED_BY_NEWER: { text: '더 최신 변경으로 대체', tone: '중립' },
  SCOPE_RETIRED: { text: '반영 대상 없음', tone: '중립' },
}

/**
 * `FAILED` 중 **사장님이 할 수 있는 일이 다른** 사유 (§16.157).
 *
 * `RULE_STALE` 은 플랫폼 화면이 바뀌어 그 룰 배포판이 응답을 읽지 못한다는 뜻이다 — 서버가 그
 * capability 선언을 내렸으므로 사장님이 다시 저장해도 같은 실패가 반복되지 않고 그 필드는
 * "해당 변경 미지원" 으로 떨어진다. 일반 `반영 실패`(플랫폼이 요청을 거절했다)와 대응이 다르므로
 * 같은 문구로 접지 않는다. 문구가 `resultCode` 에 의존하는 두 번째 자리이며, 규칙은
 * [SUPERSEDED_CHIP] 과 같다.
 */
const FAILED_CHIP = {
  RULE_STALE: { text: '플랫폼 변경으로 반영 중단 (룰 갱신 필요)', tone: '실패' },
  // ★ **가장 흔한 실패 사유**인데 종전에는 여기 없어 「반영 실패」로 접혔다.
  // `note` 는 이 표가 들고 있는 **정적 기본값**이고, 서버가 사유를 알아 `resultMessage` 를
  // 내려 주면 [decorate] 가 그쪽을 쓴다 — 서버가 말할 수 있게 되는 날 이 줄을 지우지 않아도 된다.
  //
  // ★★ **text 는 사유를 단정하지 않는다.** `note` 는 서버 문장이 덮지만 **text 는 어떤 경우에도
  // 덮이지 않는다** — 이 한 칸이 값 거절 · 429 · 5xx · 권한 없음 · 사유 미상을 전부 담는다.
  // 「값을 거절함」이라 쓰면 429(값이 평가조차 안 됨)와 5xx(반영됐을 수 있음)에 대해 거짓이다.
  PLATFORM_REJECTED: { text: '배달앱이 반영을 거절함', tone: '실패', note: PLATFORM_REJECTED_ACTION },
}

/**
 * `UNSUPPORTED` 중 **사장님이 할 수 있는 일이 다른** 사유 (§16.256).
 *
 * 「해당 변경 미지원」은 *「우리가 아직 못 민다」*로 읽힌다 — 사장님은 기다리면 되는 줄 안다.
 * 본사가 소유한 메뉴판은 **아무도 켤 수 없고**, 할 일이 오더엔이 아니라 **본사에 있다.**
 * 두 사유를 한 칸에 담으면 화면이 거짓을 말한다 — `EXEC-REJECTION-REASON-LOST` 가 정확히
 * 그 접힘이었다(§16.245①).
 *
 * `note` 는 정적 기본값이고, 서버가 본사 이름을 알아 `resultMessage` 를 내려 주면
 * [decorate] 가 그쪽을 쓴다 — 이름이 있는 문장이 언제나 낫다.
 */
const UNSUPPORTED_CHIP = {
  MANAGED_EXTERNALLY: {
    text: '본사가 관리하는 메뉴',
    tone: '중립',
    // ★ 정본은 서버 허용 집합 `DeliveryMenuManagement.IMMUTABLE_MENUPAN_WRITABLE`(§16.256⑤⑦ 리얼 왕복)이고
    // 이 note 는 그 **사본**이다 — 서버 `message()` 가 같은 집합에서 문장을 파생해 `resultMessage` 로
    // 내리면 [decorate] 가 그쪽을 쓴다. 열린 축: 배달 가격·품절·숨김 · 옵션 품절·추가금액·숨김(§16.302) /
    // 닫힌 축: 이름·설명·옵션 구조(그룹 연결·선택 개수)·포장 가격. 집합이 바뀌면 여기도 같이 바꾼다.
    note:
      '본사가 관리하는 메뉴라 이름·설명·옵션 구성(그룹 연결·선택 개수)·포장 가격은 오더엔에서 바꿀 수 없습니다. ' +
      '배달 가격·품절·숨김(삭제)과 옵션 품절·추가금액·숨김(삭제)은 그대로 반영됩니다.',
  },
}

/**
 * 플랫폼 상태 한 건 → chip 재료.
 *
 * @param {object} platformStatus `DeliveryMenuPlatformStatus`
 * @returns {{text: string, tone: string, tagType: string, resolve: ?string, note: ?string}}
 *   `resolve` 는 사장님을 어느 화면으로 보내야 하는가 — `'ORPHAN'`(③) | `'DRIFT'`(④) | `null`.
 *   `note` 는 서버가 만든 추가 설명(`resultMessage`)이며 있을 때만 보조로 표시한다.
 */
/**
 * 링크가 없는 플랫폼의 chip — **사유별로 다른 말** (§16.216).
 *
 * 사유를 모르면(옛 서버·축 부재) 종전 문구 그대로다 — 새 축이 없다고 화면이 깨지지 않는다.
 */
function unlinkedChip(reason) {
  if (reason === 'NOT_MAPPED') {
    // 이 매장은 그 배달앱을 쓰지 않는다. **할 일이 없으므로 경고하지 않는다** — 대다수 매장이
    // 여기이고, 여기에 「가져오기를 누르세요」를 띄우면 없는 걱정을 만든다.
    return { text: '이 배달앱 미사용', tone: '중립' }
  }
  if (reason === 'NEVER_IMPORTED') {
    return { text: IMPORT_REQUIRED_TEXT, tone: '경고' }
  }
  if (reason === 'MENU_ABSENT') {
    return { text: '배달앱에 이 메뉴 없음', tone: '중립' }
  }
  return { text: '미연동', tone: '중립' }
}

/**
 * ★ **삭제 확인창의 판정 — 이 메뉴들에 배달 링크가 있는가** (§16.302).
 *
 * 재료는 화면이 이미 읽어 둔 ① 상태 응답(`DeliveryMenuStatusRow.platforms[]`)이다 — 새 조회를 만들지
 * 않는다. `linkState` 가 `null` 인 플랫폼은 링크가 없다는 뜻이고([deliveryMenuChip] 이 먼저 보는 그
 * 축이다), 상태를 아직 안 읽은 메뉴는 원소가 `null` 이다.
 *
 * ★ **단정은 `LINKED` 에만 한다.** `AMBIGUOUS`·`ORPHAN`·`STALE` 은 링크 행은 있어도 실행이
 * `BLOCKED_LINK` 로 닫히는 상태라(§16.3) 「숨김 처리됩니다」가 거짓이다 — 그 링크만 있으면 「모른다」
 * (조건문)로 접는다. 링크 행이 하나도 없다고 **전부 읽어서** 아는 경우에만 `false` 다.
 *
 * @param {Array<?object>} statuses 체크한 메뉴마다 하나. `null` = 그 메뉴의 상태를 안 읽었다
 * @returns {boolean|null} `LINKED` 링크가 하나라도 있으면 `true` · 전부 읽었고 링크 행이 없으면 `false` ·
 *   안 읽은 메뉴가 있거나 실행이 막힌 링크뿐이면 `null`(모른다)
 */
export function deliveryLinkedOf(statuses) {
  const rows = statuses || []
  const states = (row) => ((row && row.platforms) || []).map((p) => p && p.linkState)
  if (rows.some((row) => states(row).some((s) => s === LINK_STATE.LINKED))) return true
  const allRead = rows.length > 0 && rows.every((row) => !!row && Array.isArray(row.platforms))
  if (!allRead) return null
  return rows.some((row) => states(row).some((s) => s != null)) ? null : false
}

/**
 * ★ **옵션 항목 삭제 확인창의 판정 — 이 옵션그룹이 배달앱에 있는가** (§16.302).
 *
 * 재료는 옵션그룹 화면이 이미 읽어 둔 echo(`DeliveryMenuOptionGroupEcho`)다. `rows` 는 **이 매장에
 * 링크가 있는 플랫폼**마다 한 줄이고 `groupCount` 는 그 플랫폼에서 이 이름으로 관측된 그룹 수다 —
 * 빈 `rows` 는 매장에 링크가 없다는 뜻이고, 줄은 있는데 전부 0 이면 「배달앱에 없다」와 「안 읽었다」가
 * 같은 값이라 가를 수 없다(§16.216 — 모르는 것을 아는 척하지 않는다).
 *
 * @param {?object} echo `GET /api/delivery-menu/option-groups/{cd}/echo` 응답. `null` = 안 읽었다·실패
 * @returns {boolean|null} 관측된 그룹이 있으면 `true` · 매장에 링크가 없으면 `false` · 그 밖은 `null`
 */
export function deliveryOptionGroupLinkedOf(echo) {
  if (!echo || !Array.isArray(echo.rows)) return null
  if (echo.rows.some((row) => row && row.groupCount > 0)) return true
  return echo.rows.length === 0 ? false : null
}

export function deliveryMenuChip(platformStatus) {
  const status = platformStatus || {}
  // linkState 가 null 이면 그 플랫폼에 링크가 없다. lastItem 을 보기 전에 이것이 먼저다.
  //
  // ★ **왜 없는지까지 말한다** (§16.216). 종전에는 서로 다른 세 사실이 「미연동」 한 마디로
  // 접혔는데 **셋의 답이 각각 다르다** — 배달앱을 안 쓰는 매장에는 할 일이 없고, 가져오기를
  // 안 한 매장은 POS 에서 한 번 누르면 되고, 배달앱에 메뉴가 없는 경우는 배달앱에서 만들어야
  // 한다. dev 실측에서 item 202건이 이 갈래였다(요기요 98 · 쿠팡 81 · 배민 23).
  if (status.linkState == null) return decorate(unlinkedChip(status.unlinkedReason), null)

  if (status.linkState === LINK_STATE.STALE) {
    // 오더엔에서 내린(삭제·사용 안 함) 메뉴 — 숨김 push 는 이 링크에서도 실행되므로(§16.218 · §16.302)
    // **마지막 작업 상태를 뒤에 이어 붙인다.** 「배달앱 숨김」이라 단정하면 item 이 미지원·실패·대기여도
    // 숨겼다고 말하게 된다. 상태 낱말은 새로 만들지 않고 [itemChip] 이 접는 표 그대로다 — 작업이
    // 없으면(그 축이 열리기 전에 내린 링크) 접두만 남고, §11.2 대로 자동으로 밀지 않으므로
    // 「플랫폼 값 다름」(④)이 그 사실을 따로 말한다.
    const stale = { text: '오더엔에서 내린 메뉴', tone: '중립', note: STALE_LINK_HIDDEN_NOTE }
    if (!status.lastItem) return decorate(stale, null)
    // 접두·기본 부기를 표 위에 덧씌우는 것도, 부기를 합치는 것도 [itemChip]·[decorate] 한 쌍의 규칙이다 — 여기서 따로
    // 합치지 않는다 (14R P44 보강: 원천 부기가 STALE 기본 부기를 밀어내던 갈래)
    return itemChip(status.lastItem, stale)
  }
  if (status.linkState === LINK_STATE.ORPHAN) {
    return decorate({ text: '메뉴 연결 필요', tone: '경고', resolve: 'ORPHAN' }, null)
  }
  if (status.linkState === LINK_STATE.AMBIGUOUS) {
    // 확정은 이 chip 의 linkId 로 여기서 바로 할 수 있고, **③ 목록에도 뜬다** (§16.257).
    // 두 자리가 같은 확정 대화상자를 쓴다 — ①은 그 메뉴를 보고 있을 때, ③은 어느 메뉴가
    // 걸렸는지 모를 때의 자리다.
    return decorate({ text: '메뉴 연결 확인 필요', tone: '경고', resolve: 'BIND' }, null)
  }

  // **실행 축이 비었으면 그것이 가장 중요한 사실이다** (§16.158).
  //
  // 서버 저장 계약(§16.54)은 배민·요기요에서 `menuGroupRef` 를 비워도 통과시키지만 3사 mutation 룰은
  // 예외 없이 그 값을 필수로 본다. 그래서 이 링크는 **정상이고 `IN_SYNC` 로 보이는데** 그 링크를
  // 향한 모든 반영이 룰 단에서 `VALIDATION_FAILED` 로 끝난다 — `lastItem` 은 그 원인을 말하지
  // 못하므로(마지막 작업이 성공이었을 수도 있다) status chip 보다 **앞에서** 답해야 한다.
  // 해소 경로는 실행자가 그 축을 읽어 다시 올리는 것이라 "메뉴 가져오기"로 안내한다.
  if (status.placementIncomplete === true) {
    return decorate({ text: `${IMPORT_REQUIRED_TEXT} (그룹 정보 없음)`, tone: '경고' }, null)
  }

  const item = status.lastItem
  if (!item) {
    // 링크는 있으나 아직 어떤 작업도 없었다. 정책이 꺼져 있으면 그 사실이 먼저다.
    if (status.syncEnabled === false) return decorate(STATUS_CHIP[ITEM_STATUS.DISABLED], null)
    return decorate({ text: '반영 이력 없음', tone: '중립' }, null)
  }
  return itemChip(item)
}

/**
 * 옵션 항목의 플랫폼 chip — `GET /api/delivery-menu/option-status` 의 `items[].platforms[]` 한 건
 * (POS 임베드 결정 브리프 2026-09-03 · D6).
 *
 * 메뉴 chip([deliveryMenuChip])과 **같은 표**를 쓰고, 옵션 축에만 있는 두 사실을 링크가 살아 있을 때 먼저 말한다:
 *
 * - `fieldSupported === false` — 그 플랫폼 capability 에 `optionSoldOut` 이 없다. 링크가 있어도 이 항목의 품절은
 *   나가지 않으므로 마지막 작업보다 앞선다. 낱말은 새로 만들지 않는다 — `UNSUPPORTED` 의 「해당 변경 미지원」.
 * - `match` — 관측 그래프에서 이 옵션을 **이름으로** 찾은 결과. `MISSING`(없음)·`AMBIGUOUS`(같은 이름 둘)면 실행이
 *   접히므로(§16.203 `UNKNOWN_PLATFORM_ITEM`·`AMBIGUOUS_OPTION_ITEM`) 경고 톤이고, 부기가 할 일을 말한다.
 *   `EXACT`·`null` 은 메뉴 chip 규칙 그대로(마지막 작업 → 문구).
 *
 * @param {object} optionPlatform `{platform, linkState, unlinkedReason, match, observed, lastItem, fieldSupported}`
 * @param {string} optionName 부기에 적을 옵션 이름
 */
export function deliveryOptionChip(optionPlatform, optionName) {
  const status = optionPlatform || {}
  if (status.linkState === LINK_STATE.LINKED) {
    if (status.fieldSupported === false) return decorate(STATUS_CHIP[ITEM_STATUS.UNSUPPORTED], null)
    if ((status.mappingReasons || []).includes('ITEM_IDS_UNREAD')) {
      return decorate(
        { text: '옵션 식별 정보 확인 필요', tone: '경고', note: optionMappingReason('ITEM_IDS_UNREAD') },
        null
      )
    }
    if (status.match === OPTION_MATCH.MISSING) {
      // 「읽었는데 없음」과 「아직 못 읽음」을 가른다 — `observed == null` 이 후자다 (§16.304②)
      if (!status.observed) {
        return decorate({ text: OPTION_MATCH_UNREAD_TEXT, tone: '경고', note: OPTION_OUTBOUND_NEEDS_IMPORT }, null)
      }
      return decorate(
        { text: OPTION_MATCH_MISSING_TEXT, tone: '경고', note: deliveryOrdernOnlyItemsNote([optionName || '이 옵션']) },
        null
      )
    }
    if (status.match === OPTION_MATCH.AMBIGUOUS) {
      return decorate({ text: OPTION_MATCH_AMBIGUOUS_TEXT, tone: '경고', note: OPTION_ITEM_AMBIGUOUS_NOTE }, null)
    }
  }
  return deliveryMenuChip(status)
}

/**
 * **원천 매장이 이 계정의 스코프 밖인 작업의 부기** (`originVisible === false`, 12R P19 · 13R P37 · 14R P49) — 판정 한 줄.
 * 서버가 그때 `shops`·`resultMessage` 를 비워 내리므로 「같은 사업장의 다른 매장이 보낸 작업」은 화면이 적는다. 메뉴 축 세
 * 화면(①·상세·matrix)과 POS 옵션 축이 같은 말을 한다. 표시 자리는 둘이다: chip 부기([decorate] 가 표의 부기 뒤에 병기)와,
 * chip 이 [itemChip] 앞에서 빠지는 갈래(미지원·지목 실패·연결 없음·`placementIncomplete`)의 옵션 상세 드로어 한 줄
 * (`PosSoldoutOptionDetailDrawer.lastItemLine`). 축이 없는 옛 응답은 보이는 것으로 읽는다(`null`).
 */
export function originHiddenNote(item) {
  return item && item.originVisible === false ? POS_SOLDOUT_TEXT.ORIGIN_OTHER_STORE : null
}

/**
 * 마지막 작업(`lastItem`) 한 건 → chip. **표 넷을 접는 유일한 자리**다 — `STALE` 링크가 접두로 붙이는
 * 문구도 여기를 지나므로 상태 낱말이 두 곳에서 갈리지 않는다.
 *
 * @param stale `STALE` 링크의 접두·기본 부기 `{text, tone, note}` — 표의 chip 위에 덧씌운다(텍스트는 접두로, 부기는 표에
 *   없을 때의 기본값으로). 부기를 합치는 규칙은 [decorate] 하나다(14R P44 보강).
 */
function itemChip(item, stale) {
  const table = (item.status === ITEM_STATUS.SUPERSEDED
    ? SUPERSEDED_CHIP[item.resultCode] || { text: '더 최신 변경으로 대체', tone: '중립' }
    : (item.status === ITEM_STATUS.FAILED && FAILED_CHIP[item.resultCode]) ||
      // 미지원도 사유별로 갈린다 (§16.256) — 실패 축과 **같은 모양**이라 표만 하나 더 둔다.
      (item.status === ITEM_STATUS.UNSUPPORTED && UNSUPPORTED_CHIP[item.resultCode]) ||
      STATUS_CHIP[item.status]) || { text: item.status, tone: '중립' }
  const base = stale ? { ...table, text: `${stale.text} · ${table.text}`, note: table.note || stale.note } : table
  return decorate(base, item.resultMessage || null, originHiddenNote(item))
}

/**
 * chip 한 건의 모양 — **부기의 규칙은 여기 하나다** (14R P44).
 *
 * ① 설명 부기: 서버가 만든 설명이 언제나 이긴다 — chip 표의 `note` 는 서버가 **아직 말할 수 없는** 사유에 대한 기본값일
 *    뿐이다. 표에 `note` 가 없는 chip 은 종전과 똑같이 동작한다(undefined → null).
 * ② 원천 부기(`originNote` — 다른 매장이 보낸 작업, [originHiddenNote]): **다른 축의 사실**이라 ①을 밀어내지 않고 뒤에
 *    병기한다. 배달앱 거절은 이 매장 링크의 사실이라 행동 안내(`PLATFORM_REJECTED_ACTION`)·STALE 기본 부기가 사라지면
 *    손해다. 호출부는 갈래를 두지 않는다 — 값을 넘길 뿐이다.
 */
function decorate(base, note, originNote) {
  return {
    text: base.text,
    tone: base.tone,
    tagType: TONE_TAG_TYPE[base.tone] != null ? TONE_TAG_TYPE[base.tone] : 'info',
    resolve: base.resolve || null,
    note: [note || base.note || null, originNote || null].filter(Boolean).join(' · ') || null,
  }
}

/** 드리프트 판정 한 건 → 배지 문구. `fields` 가 차단 근거다 */
export function driftBadge(drift) {
  if (!drift || drift.state === DRIFT_STATE.IN_SYNC) return null
  if (drift.state === DRIFT_STATE.UNKNOWN) return { text: '플랫폼 값 미확인', tagType: 'info' }
  return { text: '플랫폼 값 다름', tagType: 'warning' }
}

/**
 * **샵 하나를 화면에 어떻게 적는가** — `이름(번호)` 한 줄. 이 파일이 소유하는 유일한 규칙이다 (§16.179).
 *
 * ```text
 * 고담모담(1075202)      ← 이름을 안다
 * 1075202               ← 아직 모른다 (옛 링크는 전부 이렇다)
 * ```
 *
 * **번호를 툴팁·부제로 숨기지 않는다.** 사장님과 운영자가 문의·진단에서 실제로 주고받는 값이고,
 * 실행자 룰 셀렉터와 맞대는 유일한 축이라 눈에 보이는 자리에 있어야 한다.
 *
 * **이름을 모르면 번호만** 적는다 — `(1075202)`·`— (1075202)` 같은 자리표시자를 만들지 않는다.
 * 서버의 `shopNm == null` 은 "아직 그 샵의 이름을 관측하지 못했다"이고(§16.41), 그 상태에 이름
 * 자리를 비워 두면 화면이 "이름이 빈 가게"라는 없는 사실을 말하게 된다.
 *
 * **이름이 앞인 것도 규칙의 일부다.** 폭이 좁은 열은 `show-overflow-tooltip` 으로 잘리는데, 번호가
 * 앞이면 잘려 남는 것이 번호가 되어 이 축을 연 이유가 사라진다.
 *
 * 컴포넌트마다 `shopNm ? \`${shopNm}(${shopNo})\` : shopNo` 를 적으면 안 되는 이유가 그 셋이다 —
 * 갈래가 한 줄짜리 삼항이 아니라 세 규칙의 묶음이고, 화면마다 적으면 그중 하나씩 어긋난다.
 *
 * @param {?object} shop `{shopNo, shopNm}` — ③·④·①·② 응답의 링크 행과 `shops[]` 원소가 같은 모양이다
 * @returns {string} 화면에 그대로 적는 한 줄
 */
export function shopText(shop) {
  const shopNo = shop && shop.shopNo != null ? String(shop.shopNo).trim() : ''
  const shopNm = shop && typeof shop.shopNm === 'string' ? shop.shopNm.trim() : ''
  if (!shopNm) return shopNo || '-'
  return shopNo ? `${shopNm}(${shopNo})` : shopNm
}

/**
 * `lastItem.shops[]` 부기 — 복수면 함께 반영된다는 사실을 드러낸다 (§9.2 · §16.179).
 *
 * **다른 자리와 같은 표기를 쓴다** ([shopText]). 이 부기가 뜨는 자리가 정확히 "여러 가게에 함께
 * 나간다"를 알리는 자리라, 번호만 적으면 사장님은 무엇에 동의하는지 읽을 수 없다.
 */
export function shopsNote(shops) {
  if (!shops || shops.length <= 1) return null
  return `${shops.map(shopText).join(', ')} 함께 반영`
}

/** 드리프트 필드 어휘 (`DeliveryMenuField`) — 서버가 내리는 문자열 그대로다 */
export const DELIVERY_MENU_FIELD = {
  SMENU_NM: 'smenuNm',
  SMENU_DESC: 'smenuDesc',
  PRICE: 'price',
  /**
   * 포장 채널 가격 — 배민·땡겨요가 갖는다 (§16.171·§16.307). 어느 플랫폼이 갖는지는 플랫폼 표
   * (`platformHasPickupChannel`)가 답한다.
   *
   * **정정**: 초판 주석은 *"관측·판정 전용 축이라 아웃바운드가 없다"* 였으나 거짓이다 —
   * capability 에 `BAEMIN UPDATE/pickupPrice` 행이 서 있고, 사장님이 포장 목표를 정한 링크에서는
   * 실제로 나간다. 목표를 말한 적 없는 링크에서만 patch 에서 빠진다
   * (`DeliveryMenuPrice.unpushableChannelFields`).
   */
  PICKUP_PRICE: PICKUP_PRICE_FIELD,
  STOP_SELLING: 'stopSelling',
  STOP_REASON: 'stopReason',
  /** 오더엔의 삭제·「사용 안 함」= 배달앱 숨김, 3사 통일 (규약 §16.302). 부기는 `deliveryFieldNote` */
  USE_YN: USE_YN_FIELD,
  /**
   * **메뉴가 쓰는 옵션그룹** (§16.198·§16.199) — 값은 이름의 JSON 배열 문자열이다.
   *
   * 이 축은 `observed_snapshot` **밖**(링크의 `observed_option_groups` 컬럼)에 살지만, 서버가
   * 판정·화면에 내릴 때 두 스냅샷을 같은 함수로 넓혀 실어 준다(§16.202). 그래서 이 표에 라벨이
   * 없으면 값 차이 화면이 **wire 원문 `optionGroups`** 를 그대로 그린다 — 2026-08-21 dev 에서
   * 실제로 그렇게 떴다.
   */
  OPTION_GROUPS: 'optionGroups',
  OPTION_SOLD_OUT: 'optionSoldOut',
  /** 구조 축 — 실행 대상이 옵션그룹인 것은 품절 축과 같다 (규약 §16.204) */
  OPTION_SELECT_COUNT: 'optionSelectCount',
  OPTION_ITEM_PRICE: 'optionItemPrice',
  /**
   * 옵션 항목 **숨김** (규약 §16.302) — 옵션 항목의 삭제·「사용 안 함」이 배달앱 숨김으로 나간다.
   * 값은 품절 축과 같은 모양(`[{"g","i","u"}]`)이고 실행 대상도 옵션그룹이다.
   */
  OPTION_USE_YN: OPTION_USE_YN_FIELD,
}

/** 필드 어휘 → 사람이 읽는 라벨. 라벨은 프론트 몫이다 */
const FIELD_LABELS = {
  [DELIVERY_MENU_FIELD.SMENU_NM]: '메뉴명',
  [DELIVERY_MENU_FIELD.SMENU_DESC]: '메뉴 설명',
  [DELIVERY_MENU_FIELD.PRICE]: '가격',
  [DELIVERY_MENU_FIELD.PICKUP_PRICE]: '포장 가격',
  [DELIVERY_MENU_FIELD.STOP_SELLING]: '판매 정지',
  [DELIVERY_MENU_FIELD.STOP_REASON]: '정지 사유',
  [DELIVERY_MENU_FIELD.USE_YN]: '사용 여부',
  [DELIVERY_MENU_FIELD.OPTION_GROUPS]: '옵션그룹',
  [DELIVERY_MENU_FIELD.OPTION_SOLD_OUT]: '옵션 품절',
  [DELIVERY_MENU_FIELD.OPTION_SELECT_COUNT]: '옵션 선택 개수',
  [DELIVERY_MENU_FIELD.OPTION_ITEM_PRICE]: '옵션 추가금액',
  [DELIVERY_MENU_FIELD.OPTION_USE_YN]: OPTION_USE_YN_LABEL,
}

export function deliveryFieldLabel(field) {
  return FIELD_LABELS[field] || field
}

/**
 * 화면 문구(포장 조건·부기)와 채널 어휘는 `deliveryMenuNotes.js` 가 소유한다 — 이 파일 위에서
 * 그대로 재수출하므로 호출부의 import 경로는 바뀌지 않는다. 옮긴 이유는 그 파일 머리주석에 있다.
 */

/** 플랫폼 코드 → 표시명. deliveryPlatform.js 가 SSOT이며 여기서 다시 정의하지 않는다 */
export function deliveryMenuPlatformName(platform) {
  return platformDisplayName(platform)
}

/**
 * **관측 가격이 숫자로 읽히는가** — `observedPrice` 는 문자열이고 숫자가 아닐 수 있다 (가이드 §4).
 *
 * 값이 없거나 숫자가 아니면 `materialize` 로 만들어지는 메뉴의 가격이 `0` 이 되므로, 그 갈래를
 * 가르는 것도 이 술어다 — 표시와 판단이 같은 문장을 지나야 화면이 두 말을 하지 않는다.
 */
export function hasObservedPrice(raw) {
  if (raw == null || raw === '') return false
  return Number.isFinite(Number(raw))
}

/**
 * 관측 가격 원문 → 표시 문자열.
 *
 * 숫자가 아니면 **원문을 그대로** 보여 준다 — 관측 원문이 숫자가 아니라는 사실 자체가 진단
 * 정보이기 때문이다(가이드 §4). ③ 목록·연결 대화상자가 같은 문장을 쓴다.
 *
 * **포매터를 주입받지 않는다** — `util.formatMoney` 는 `this.isEmpty` 를 쓰므로 함수만 떼어
 * 넘기면 `this` 가 없어 호출 순간 던진다(그 행이 통째로 빈 칸이 된다). 시각을 주입받는
 * [deliveryMenuTimeText] 와 갈리는 이유가 그것이다 — `util.getDate` 는 `this` 를 쓰지 않는다.
 */
export function observedPriceText(raw) {
  if (!hasObservedPrice(raw)) return raw == null || raw === '' ? '-' : String(raw)
  return util.formatMoney(Number(raw))
}

/**
 * **관측한 옵션 개수 → 표시 문자열** — ③ 목록·`새 메뉴로 등록` 대화상자·등록 결과가 같은 문장을 쓴다 (§16.195).
 *
 * 세 상태를 **뭉뚱그리지 않는 것**이 이 함수의 전부다.
 *
 * | 값 | 뜻 | 문구 |
 * |---|---|---|
 * | `null`·`undefined` | 아직 옵션을 관측한 적 없다 | `읽지 못함` |
 * | `0` | 배달앱에 옵션이 없다고 관측했다 | `없음` |
 * | `n > 0` | 그만큼 함께 등록된다 | `n개` |
 *
 * `null` 과 `0` 을 같은 말로 적으면 사장님은 **왜** 옵션이 안 왔는지 화면 어디에서도 알 수 없다 —
 * 그것이 이 CS(2026-08-18)의 시작이었다. 서버가 두 값을 갈라 내리는 이유도 같다.
 */
export function observedOptionText(count) {
  if (count == null) return '읽지 못함'
  return count === 0 ? '없음' : `${count}개`
}

/**
 * **옵션을 관측했는가** — 표시와 판단이 같은 술어를 지난다([hasObservedPrice] 와 같은 자리).
 *
 * 거짓이면 `새 메뉴로 등록`은 **옵션 없는 메뉴**를 만든다. 그 사실을 누르기 전에 말해야 한다.
 */
export function hasObservedOptions(count) {
  return count != null
}

/**
 * ④ `POST /drift/resolve` 응답 → 결과 문구.
 *
 * 두 갈래가 **다른 사실을 센다** (`DeliveryMenuDriftResolveResponse.changeCount`).
 *
 * - `PUSH_ORDERN` — 만든 요청(`intentIds`)과 **그중 실행을 기다리는 item**(`pendingItemCount`)은
 *   다른 사실이다 (§16.168). 요청만 말하면 전부 막힌 결정이 "성공"으로 읽힌다.
 * - `ACCEPT_PLATFORM` — 오더엔 메뉴 행(`updatedSmenuCds`)과 **링크의 채널 가격**
 *   (`updatedPriceLinkIds`)이 같은 갈래의 두 자리다 (§16.171). 가격만 갈린 결정은 메뉴 행을 한 줄도
 *   고치지 않으므로, 이 목록을 세지 않으면 화면이 "아무것도 안 바뀌었다"고 말하게 된다.
 *   **0 인 자리는 적지 않는다** — "0건 수정"이 그 거짓말의 다른 모양이다.
 */
export function driftResolveSummary(result) {
  if (!result) return ''
  if (result.resolution === DRIFT_RESOLUTION.PUSH_ORDERN) {
    const intents = (result.intentIds || []).length
    return `반영 요청을 만들었습니다: ${intents}건 / 실행 대기 ${result.pendingItemCount || 0}건`
  }
  const parts = []
  const menus = (result.updatedSmenuCds || []).length
  const priceLinks = (result.updatedPriceLinkIds || []).length
  if (menus > 0) parts.push(`오더엔 메뉴 ${menus}건 수정`)
  if (priceLinks > 0) parts.push(`배달앱 채널 가격 ${priceLinks}건 반영`)
  // 서버가 `changeCount()==0` 을 400 으로 거절하므로 200 응답이 여기 오지 않는다.
  // 그래도 빈 문구를 내지 않는 것은, 침묵이 "바뀐 것이 없다"보다 읽기 어렵기 때문이다.
  return parts.length > 0 ? parts.join(' · ') : '바뀐 값이 없습니다.'
}

/**
 * ④ `ACCEPT_PLATFORM` 확정 전 경고 — **그 행이 걸린 축만** 말한다.
 *
 * 형제 매장 전파는 언제나 경고한다(§11.2 — 미리보기 API 가 없어 사장님이 그것을 알고 눌러야 한다).
 * 가격 두 줄은 그 행에 해당 축이 있을 때만 붙인다 — 요기요·쿠팡에는 포장 가격 필드 자체가 없어
 * (§16.171) 늘 붙이면 없는 걱정을 만든다. 포장 조건 문장도 그 행의 플랫폼 것만 붙는다(배민·땡겨요가 다르다).
 */
export function acceptPlatformConfirmText(row) {
  const blocking = (row && row.fields) || []
  const displayOnly = (row && row.unsupportedDiffFields) || []
  const lines = [
    '배달앱 값을 오더엔 메뉴에 반영합니다. 이름·설명은 원본 축이라 이 메뉴를 함께 쓰는 형제 매장에도 전파될 수 있습니다.',
  ]
  if (blocking.some((f) => f && f.field === DELIVERY_MENU_FIELD.PRICE)) {
    // 가격이 링크마다 갈려도 더 이상 거절이 아니다 — 각 링크가 자기 값을 받는다 (§16.171)
    lines.push('가격은 배달앱 연결마다 다를 수 있어 값이 갈려도 각 연결에 그 값이 저장됩니다.')
  }
  // 포장 조건은 플랫폼마다 다르다 — **그 행의 플랫폼 문장만** 붙인다(배민 행에 땡겨요 조건은 없는 걱정이다, §16.7)
  const pickupNote = deliveryFieldNote(DELIVERY_MENU_FIELD.PICKUP_PRICE, row && row.platform)
  if (pickupNote && displayOnly.some((f) => f && f.field === DELIVERY_MENU_FIELD.PICKUP_PRICE)) {
    lines.push(pickupNote + '.')
  }
  return lines.join(' ')
}

// ────────────────────────────────────────────────────────────────────
// 채널별 목표 가격 — 메뉴 수정 화면 (§16.177)
// ────────────────────────────────────────────────────────────────────

// **그 플랫폼에 포장 축이 있는가**(`platformHasPickupChannel`)는 플랫폼 표가 답한다 — 위 재수출 그대로다.

/**
 * `GET /menus/{smenuCd}/channel-prices` 응답 → **편집 축인 (플랫폼, 채널) 행**.
 *
 * 응답의 축은 **링크**이고 요청의 축은 **(플랫폼, 채널)**이다 — 한 플랫폼에 링크가 여럿일 수 있고
 * (한 샵에 판이 둘, 또는 매장이 같은 플랫폼에 샵을 여럿) 요청은 같은 `(platform, channel)` 을 두 번
 * 실으면 400 이다. 그래서 화면은 링크를 플랫폼으로 접어 편집하고, 접힌 값이 서로 다르면 그 사실을
 * 드러낸다(`mixed`) — 링크마다 다른 것은 **정상**이라 화면이 임의로 하나를 골라 보여주면 저장하지도
 * 않은 통일이 일어난 것처럼 읽힌다.
 *
 * @returns `[{platform, links, channels: {DELIVERY: {value, mixed}, PICKUP: {…}|null}}]`
 */
export function channelPriceRows(response) {
  const links = (response && response.links) || []
  const byPlatform = new Map()
  for (const link of links) {
    if (!byPlatform.has(link.platform)) byPlatform.set(link.platform, [])
    byPlatform.get(link.platform).push(link)
  }
  return Array.from(byPlatform.entries()).map(([platform, platformLinks]) => ({
    platform,
    links: platformLinks,
    channels: {
      [DELIVERY_MENU_CHANNEL.DELIVERY]: foldOverride(platformLinks, 'deliveryOverride'),
      [DELIVERY_MENU_CHANNEL.PICKUP]: platformHasPickupChannel(platform)
        ? foldOverride(platformLinks, 'pickupOverride')
        : null,
    },
  }))
}

/** 그 플랫폼 링크들의 오버라이드를 하나로 접는다. 갈리면 `mixed` 이고 입력칸은 비어 있다 */
function foldOverride(links, field) {
  const values = links.map((link) => (link[field] == null ? null : Number(link[field])))
  const mixed = values.some((value) => value !== values[0])
  return { value: mixed ? null : values[0], mixed }
}

/**
 * 입력칸의 값 → 요청에 실을 가격.
 *
 * **빈 칸은 `null` 이고 그것이 "해제"다.** ★ **해제 뒤 무엇이 되는지는 채널마다 다르다**
 * (§16.221③·§16.227①) — 배달 축은 메뉴 행 가격으로 돌아가지만 **싯가 메뉴에서는 목표가 사라지고**,
 * 포장 축은 애초에 집이 없어 언제나 목표가 사라진다. 화면이 그 답을 다시 적지 않는다 — 서버가
 * 내려주는 실효값(`delivery`/`pickup`)이 정본이다. `0` 은
 * 정상적인 목표라 빈 칸으로 접으면 안 된다.
 */
export function channelPriceValue(raw) {
  if (raw == null || raw === '') return null
  const num = Number(raw)
  return Number.isFinite(num) ? num : null
}

/**
 * 편집 상태 → `PUT` 의 `targets[]` — **손댄 축만 싣는다** (§16.177).
 *
 * 목록에 없는 채널은 서버가 건드리지 않고, 실은 채널은 값이 `null` 이어도 **선언**이다("해제").
 * 그래서 안 만진 축까지 실으면 두 링크가 정당하게 갈라 놓은 값이 조용히 하나로 합쳐진다.
 *
 * @param drafts `{[platform]: {[channel]: {value, touched}}}`
 */
export function channelPriceTargets(drafts) {
  const targets = []
  for (const platform of Object.keys(drafts || {})) {
    const channels = drafts[platform] || {}
    for (const channel of Object.keys(channels)) {
      const slot = channels[channel]
      if (!slot || !slot.touched) continue
      targets.push({ platform, channel, price: channelPriceValue(slot.value) })
    }
  }
  return targets
}

/**
 * `PUT` 응답 → 결과 문구 (§16.177).
 *
 * **`updatedLinkIds` 가 비어도 성공이다** — 이미 그 값이면 아무것도 바뀌지 않는 것이 정상이고 그때는
 * `intentIds` 도 비어 있다. 그것을 실패처럼 말하면 사장님은 같은 저장을 반복한다.
 */
export function channelPriceSaveSummary(response) {
  const updated = ((response && response.updatedLinkIds) || []).length
  if (updated === 0) return '배달앱 채널 가격은 바뀐 값이 없습니다.'
  return `배달앱 채널 가격 ${updated}건을 저장했습니다.`
}

// ────────────────────────────────────────────────────────────────────
// ③ `materialize` 의 카테고리 (§16.178)
// ────────────────────────────────────────────────────────────────────

/**
 * 카테고리 선택 → `POST /links/materialize` 계열의 본문 축 (§16.186).
 *
 * **두 축이 함께 실린다 — 그것이 이 함수가 있는 이유다.** 오더엔 메뉴는 여러 카테고리에 동시에
 * 속할 수 있으므로(`tbl_smenu_x_category`) *"이 셋에 넣고, 없으면 하나 더 만들어 거기도 넣어라"*
 * 가 모순이 아니다. 20차의 "둘 중 하나만" 규칙은 축이 단수였기에 필요했던 것이고, 그때 서버가
 * 하나를 고르면 사장님이 화면에서 고른 것과 다른 곳에 메뉴가 들어갔다.
 *
 * `null` 은 **"아무도 말하지 않았다"** 이고, 그때 서버는 링크가 관측한 카테고리 이름으로 정한다 —
 * 관측조차 없으면(`observedCategoryNm == null`) 400 이므로 [canMaterializeCategory] 가 그 갈래를 막는다.
 * 빈 문자열·빈 선택은 서버에서도 "말하지 않은 것"으로 수렴하므로 여기서 같은 답을 낸다.
 */
export function materializeCategoryBody(choice) {
  const categoryCds = ((choice && choice.categoryCds) || []).filter((cd) => cd != null)
  const name = ((choice && choice.categoryNm) || '').trim()
  if (categoryCds.length === 0 && !name) return null
  return {
    ...(categoryCds.length > 0 ? { categoryCds } : {}),
    ...(name ? { categoryNm: name } : {}),
  }
}

/**
 * 지금 이 선택으로 `materialize` 를 부를 수 있는가 (§16.178).
 *
 * 아무것도 말하지 않은 채 부를 수 있는 것은 **링크가 카테고리 이름을 관측한 경우뿐**이다. 관측조차
 * 없는 옛 링크에서 그대로 보내면 400 이고, dev 실측에서 ORPHAN 145건 중 143건이 그 400 이었다.
 */
export function canMaterializeCategory(choice, observedCategoryNm) {
  return materializeCategoryBody(choice) != null || !!observedCategoryNm
}

/** ⑤ capability 등록 폼의 어휘 — 서버 `DeliveryMenuCapabilityRequest` 검증 축과 같다 */
export const CAPABILITY_VOCAB = {
  executorKinds: ['POS_WEBVIEW', 'BROWSER_EXT', 'SERVER_BROWSER'],
  operations: ['UPDATE', 'SOLDOUT', 'RESTORE', 'DELETE'],
  /**
   * 서버가 받는 것은 `INTENT_FIELDS + useYn + '*'` 이다 — **`pickupPrice` 는 여기 없다** (§16.171).
   * 그 축은 관측·판정 전용이라 오더엔에 편집할 컬럼이 없고, 따라서 밀 수 있는 룰도 없다. 폼이
   * 그것을 고를 수 있으면 400 을 부르거나, 더 나쁘게는 "등록했으니 반영되겠지"로 읽힌다.
   */
  fields: [
    DELIVERY_MENU_FIELD.SMENU_NM,
    DELIVERY_MENU_FIELD.SMENU_DESC,
    DELIVERY_MENU_FIELD.PRICE,
    DELIVERY_MENU_FIELD.STOP_SELLING,
    DELIVERY_MENU_FIELD.STOP_REASON,
    DELIVERY_MENU_FIELD.USE_YN,
  ],
  scopeTps: ['PRINCIPAL', 'SHOP'],
  /** 화면에 보이는 실행 표면 — 이 밖의 executorKind 는 requiresVisibleYn='Y' 선언을 해석하지 못한다 (§12) */
  visibleExecutorKinds: ['POS_WEBVIEW', 'BROWSER_EXT'],
}

/** 상태 오퍼레이션은 서버가 field 를 `*` 로 접는다 — 폼이 field 입력을 잠그는 근거 (§4.6) */
export const CAPABILITY_FIELD_ALL = '*'
export function capabilityFoldsField(operation) {
  return operation !== 'UPDATE'
}

/**
 * ③ `POST /links/{id}/materialize` 실패 → **화면이 무엇을 해야 하는가** (§16.172, 가이드 §4).
 *
 * 상태 코드마다 사장님이 할 일이 다르다. 갈래를 여기 한 곳에 두는 이유는 `bind` 와 달리 이쪽은
 * "오류가 아닌 실패"(409)를 갖기 때문이다 — 그 구분을 화면마다 적으면 한쪽이 그것을 빨간 오류로
 * 그린다.
 *
 * **상태는 `HttpError.status` 에서 온다.** `plugins/http` 인터셉터가 axios 오류를 `HttpError` 로
 * 바꿔 던지므로 `error.response` 는 오지 않는다. 이 요청은 인터셉터의 기본 오류 토스트를
 * 옵트아웃(`showErrorMessage: false`)하므로 **여기서 만든 것이 사장님이 보는 유일한 문장**이다.
 *
 * | 코드 | 사실 | 화면 |
 * |---|---|---|
 * | 409 | 그 사이 관측이 자동 확정했거나 다른 관리자가 `bind` 했다 | **오류가 아니다.** 안내 톤 + 목록 재조회 |
 * | 404 | 그 링크가 없다 | 목록이 낡았다 — 재조회 |
 * | 403 | 링크의 매장이 스코프 밖 | "권한이 없습니다" (§1 오류표) |
 * | 400 | 이름 미관측 · 폭·범위 초과 · 같은 이름 메뉴 존재 · 카테고리 미상 | **서버 문장이 다음 행동을 이미 담는다** — 그대로 노출하고 목록은 그대로 둔다 |
 *
 * 400 갈래에 프론트 문구를 덧붙이지 않는 것은 §16.57 의 반대 방향이다: 서버가 만든 그 문장이
 * `smenuCd` 나 `menuGroupRef` 같은 이 요청 고유의 사실을 담고 있어, 화면이 짐작해 지어낸 문장은
 * 그보다 정확할 수 없다.
 */
export function materializeFailure(error) {
  const status = httpStatusOf(error)
  const message = deliveryMenuErrorMessage(error)
  if (status === 409) return { tone: 'info', message, hint: '목록을 다시 읽었습니다.', refresh: true }
  if (status === 404) return { tone: 'error', message, hint: '목록을 다시 읽었습니다.', refresh: true }
  if (status === 403) return { tone: 'error', message: '권한이 없습니다.', hint: null, refresh: false }
  return { tone: 'error', message, hint: null, refresh: false }
}

/**
 * 관측 시각 표시 — **네 화면이 같은 한 곳을 지난다** (§16.167).
 *
 * 네 곳이 각자 `util.getDate('yyyy-MM-dd hh:mm', …)` 를 적고 있었고, `util.getDate` 는 `H+`(24시)만
 * 알고 `h` 는 모른다. 모르는 토큰은 거절되지 않고 **그대로 출력되므로** 화면에는
 * `2026-08-02 hh:29` 가 떴다 — 네 곳 전부에서. 이 화면들에서 관측 시각은 장식이 아니라 **판단
 * 근거**다("언제 본 값인가"를 모르면 어느 쪽이 정본인지 고를 수 없다).
 *
 * 그래서 토큰을 고치는 것으로 끝내지 않고 표현을 이 파일이 소유한다 — 같은 결정이 네 벌이었던 것이
 * 네 곳이 함께 틀린 이유다.
 */
export function deliveryMenuTimeText(value, formatDate) {
  return value ? formatDate('yyyy-MM-dd HH:mm', new Date(value)) : '-'
}

// ────────────────────────────────────────────────────────────────────
// 배달 샵 ↔ 매장 매핑 (설계 `delivery-shop-map-server-ssot-design.md` §8.2·§8.3)
// ────────────────────────────────────────────────────────────────────

/**
 * 매핑 표면 — `/api/delivery-menu` 와일드카드 **안**이다.
 *
 * 접두사가 같아야 `sys_resources` 의 기존 3행(GET=DeliveryMenuView · POST=DeliveryMenuBind)이 그대로
 * 덮는다. 리터럴로 적으면 그 사실이 코드에서 사라지고, 접두사가 어긋난 사본은 403 → 강제 로그아웃이다.
 */
export const DELIVERY_SHOP_MAP_API = `${DELIVERY_MENU_API}/shop-map`

/**
 * 이 화면의 두 요청(`/impact` · `POST /shop-map`)이 함께 싣는 옵트아웃 — **한 곳에서 파생한다**.
 *
 * 둘 다 **대체 동작을 갖는다**: 파급을 못 읽으면 저장을 멈추고(`shopMapImpactFailureText`), 저장이
 * 거절되면 그 문장을 화면이 띄운다(`shopMapAssignFailureText`). 그것이 두 옵트아웃의 조건이다.
 *
 * - `showErrorMessage: false` (§16.175) — 화면이 만든 문장 하나만 뜬다. 인터셉터의 빨간 토스트가
 *   함께 뜨면 한 번의 조작에 화면이 두 말을 한다.
 * - `logoutOn403: false` (§16.170) — **이 화면의 403 은 "세션이 무효다"가 아니라 "이 가게는 여기서
 *   바꿀 수 없다"이다.** 그 샵의 링크가 이 계정의 그룹 밖 매장에 걸려 있으면 서버가 정상적으로
 *   거절하는데(설계 §13 ⓑ), 옵트아웃이 없으면 그 거절이 세션을 지우고 사장님을 로그인 화면으로
 *   보낸다 — 컴포넌트의 `catch` 는 그보다 늦게 돌아 어떤 문장도 닿지 못한다.
 *
 * 호출부마다 적으면 한쪽만 빠진다 — 실제로 `logoutOn403` 이 두 곳 다 빠져 있었다. 그래서 상수 하나다.
 */
export const SHOP_MAP_REQUEST_CONFIG = Object.freeze({ showErrorMessage: false, logoutOn403: false })

/**
 * 아직 어느 매장의 것도 아닌 샵의 귀속 칸 (§8.2).
 *
 * 빈 칸으로 두면 "이름을 모르는 매장"으로 읽힌다 — 그 행이 화면에 있는 이유가 정확히 **매장이
 * 정해지지 않았다**는 사실이므로 그것을 글자로 말한다. 귀속을 지우는 선택지의 이름이기도 하다.
 */
export const SHOP_MAP_UNASSIGNED_TEXT = '미분류'

/**
 * 이 변경이 **뗄 것을 갖고 있는가** — 다이얼로그를 띄울지 가르는 술어 (§8.3).
 *
 * 0 이면 묻지 않는다. 되돌릴 품이 없는 조작에까지 확인을 붙이면 확인이 소음이 되고, 정작 113건이
 * 떨어지는 순간의 확인도 같은 무게로 읽힌다.
 */
export function shopMapNeedsConfirm(impact) {
  // 다른 계정에서 떼어 오는 것도 **되돌릴 수 없는 조작**이라 반드시 묻는다 (§16.192) — 내 매장에서
  // 뗄 것이 0건이어도 그렇다. 이 갈래가 없으면 이관이 확인 없이 지나간다.
  if (impact && (impact.foreignUnbind || impact.foreignHandover || impact.foreignPurge)) return true
  return ((impact && impact.unbindLinks) || 0) > 0
}

/**
 * 귀속 변경 한 줄 — **어디에서 어디로**. 확인과 결과가 같은 문장을 쓰고 시제만 다르다.
 *
 * `A → B` 로 적는 것은 조사 때문이다. 매장 이름은 사장님이 정한 값이라 받침 유무를 알 수 없고,
 * `〈통합 테스트〉로`·`〈갈매기카페 2호점〉으로` 를 한 템플릿으로 만들 수 없다 — 한쪽을 고르면
 * 다른 쪽이 틀린 문장이 된다. 화살표는 어느 이름에도 맞는다.
 */
function shopMapMoveHead(fromStoreNm, toStoreNm, done) {
  const from = fromStoreNm || SHOP_MAP_UNASSIGNED_TEXT
  const to = toStoreNm || SHOP_MAP_UNASSIGNED_TEXT
  return `${done ? '귀속 매장을 바꿨습니다' : '귀속 매장을 바꿉니다'}: 〈${from}〉 → 〈${to}〉.`
}

/**
 * **누르기 전에** 파급을 말하는 문장 (§8.3).
 *
 * 건수는 전부 서버 `/impact` 가 준 값이다 — 화면이 같은 수를 다시 세면 다이얼로그가 말한 건수와
 * 실제 언바인드 수가 갈리고, 그 차이는 사장님이 되돌린 뒤에야 드러난다.
 *
 * 위험한 조작이라서 묻는 것이 아니다. §1.1 대로 이 조작은 거의 언제나 오설정 정정이고 링크가
 * 떨어지는 것은 의도한 결과다 — **되돌리는 데 드는 품**을 누르기 전에 알려야 하기 때문에 묻는다.
 *
 * `pendingItems` 는 **취소되지 않는다**(서버 `unbind` 주석). "취소됩니다" 로 적으면 사장님은 그
 * 작업이 멈춘 줄 알고 배달앱을 다시 고치게 된다 — 겨냥하고 있다는 사실만 말한다.
 */
/**
 * 다른 계정이 걸린 이관의 고지 — **세 사실을 갈라 말한다** (§16.192 · 23차 리뷰 정정).
 *
 * 서버가 하나로 뭉쳐 내리던 동안 화면이 거짓을 말했다: 링크가 0건인 이관(가장 흔한 모양)에서도
 * 「그 매장의 연결은 지워지며 되돌릴 수 없습니다」가 나갔고, 제3 매장이 걸린 경우 그쪽은
 * 언바인드라 되돌릴 수 있는데 같은 문장이 나갔다. **되돌릴 수 없는 것은 삭제뿐이다.**
 *
 * `foreignPurge` 를 모르는 옛 서버는 그 키가 없어 `undefined` 라 삭제를 말하지 않는다 —
 * 안전한 쪽으로 떨어진다.
 *
 * @param done 결과 토스트용 시제
 */
function shopMapForeignLines(impact, done = false) {
  if (!impact) return []
  const lines = []
  if (impact.foreignPurge) {
    lines.push(
      done
        ? '그 매장의 메뉴 연결은 지워졌습니다. 되돌릴 수 없습니다.'
        : '그 매장의 메뉴 연결은 함께 지워지며 되돌릴 수 없습니다.'
    )
  }
  if (impact.foreignHandover) {
    lines.push(
      done
        ? '이 가게는 다른 매장의 것이었습니다.'
        : '이 가게는 지금 다른 매장의 것입니다. 되돌리려면 그쪽에서 다시 가져가야 합니다.'
    )
  } else if (impact.foreignUnbind) {
    // 이관은 아니고 제3 매장의 연결만 떨어지는 갈래 — 되돌릴 수 있다
    lines.push(done ? '다른 매장의 메뉴 연결이 함께 떨어졌습니다.' : '다른 매장에 연결된 메뉴도 함께 떨어집니다.')
  }
  return lines
}

export function shopMapMoveConfirmText(impact, shopLabel, toStoreNm) {
  const from = (impact && impact.fromStoreNm) || null
  const lines = [`${shopLabel} — ${shopMapMoveHead(from, toStoreNm, false)}`]
  // **세 사실을 갈라 말한다** (§16.192 · 23차 리뷰 정정). 한 문장으로 뭉쳐 두면 링크가 0건인
  // 이관에서 「지워지며 되돌릴 수 없습니다」가 **거짓**이 된다 — 지울 링크가 없었으니까. 그리고
  // 제3 매장이 걸린 경우 그쪽은 언바인드라 되돌릴 수 있는데 같은 문장이 나갔다.
  // 서버가 이름·건수를 접어 내리므로 화면이 말할 수 있는 것은 사실뿐이고, 그 편이 맞다 —
  // 남의 매장 건수는 사장님이 되돌릴 품이 아니다.
  lines.push(...shopMapForeignLines(impact))
  const unbind = (impact && impact.unbindLinks) || 0
  if (unbind > 0) {
    // 되돌리는 자리를 함께 말한다 — 사이드 메뉴의 그 화면 이름 그대로여야 찾아갈 수 있다
    lines.push(
      `${from || SHOP_MAP_UNASSIGNED_TEXT}의 이 샵 메뉴 연결 ${unbind}건이 확정 해제됩니다.` +
        ` 해제된 메뉴는 "메뉴 연결" 화면에서 다시 연결할 수 있습니다.`
    )
  }
  const pending = (impact && impact.pendingItems) || 0
  if (pending > 0) lines.push(`진행 중인 메뉴 작업 ${pending}건이 이 샵을 겨냥하고 있습니다.`)
  return lines.join(' ')
}

/**
 * 저장 응답 → 결과 문구. 응답이 확인 다이얼로그와 **같은 모양**이라 같은 축으로 말한다.
 *
 * 다이얼로그가 말한 수와 실제로 일어난 수가 다를 수 있다(그 사이 관측이 링크를 더 만들었을 수
 * 있다). 그래서 결과도 예측이 아니라 **응답의 수**로 적는다.
 */
export function shopMapAssignSummary(impact, shopLabel, toStoreNm) {
  const from = (impact && impact.fromStoreNm) || null
  const head = `${shopLabel} — ${shopMapMoveHead(from, toStoreNm, true)}`
  // 확인 문구와 **같은 축으로** 접는다 — 한쪽만 접으면 확인 창은 조용한데 결과가 남의 매장을 말한다
  const foreign = shopMapForeignLines(impact, true)
    .map((line) => ` ${line}`)
    .join('')
  const unbind = (impact && impact.unbindLinks) || 0
  if (unbind === 0) return `${head}${foreign}`
  return `${head} ${from || SHOP_MAP_UNASSIGNED_TEXT}의 메뉴 연결 ${unbind}건이 확정 해제됐습니다.${foreign}`
}

/**
 * 파급을 읽지 못했을 때 — **서버 문장 + 화면이 한 일** (§16.57 의 규칙대로 덧붙인다).
 *
 * 서버 문장은 그대로 둔다(그것이 다음 행동을 담는다). 다만 그 문장은 **이 화면이 저장을 멈췄다는
 * 사실을 모른다** — `서버 오류가 발생했습니다` 만 뜨면 사장님은 매장이 바뀌었는지 아닌지 알 수 없고,
 * 목록의 선택기는 옛 값으로 돌아와 있어 "바뀐 것 같기도 하다"로 읽힌다. 화면만 아는 사실을 덧붙인다.
 */
function shopMapImpactUnknownText(message) {
  return `${message} 파급을 확인하지 못해 매핑을 바꾸지 않았습니다.`
}

/**
 * 403 은 **이 조작의 거절**이지 세션의 끝이 아니다 — 그 사실을 사장님 말로 옮긴다 (§16.170·§16.175).
 *
 * 서버 문장(`AdminStoreScopeResolver.forbidden()` = "접근 권한이 없습니다.")은 사장님이 다음에 무엇을
 * 할 수 있는지 말하지 못한다. 이 화면에서 403 이 뜨는 자리는 하나다 — 그 샵의 링크가 **이 계정의
 * 그룹 밖 매장**에 걸려 있어 서버가 남의 데이터를 손대지 못하게 막는 것이고, 그것은 고장이 아니라
 * 설계된 거절이다(설계 §13 ⓑ).
 *
 * **사유를 화면이 지어내지 않는다** (2026-08-08 정정). 예전에는 서버 문장 뒤에 "다른 계정의 매장에
 * 걸려 있어서"를 항상 덧붙였는데, 서버는 그 사유를 **일부러 말하지 않기로** 했다 — "아직 아무도
 * 보고하지 않았다"와 "남의 것이다"가 문구로 갈리면 임의의 샵 번호로 등록 여부를 훑을 수 있어 두
 * 거절을 같은 문장으로 수렴시켰다(규약 §16.187). 화면이 뒤에 사유를 붙이면 서버가 감춘 것을 화면이
 * 되살리고, 게다가 그 사유가 사실이 아닐 수도 있다.
 *
 * 그래서 서버 문장이 있으면 **그것만** 쓴다 (§16.57). 폴백도 사유를 말하지 않는다 — 서버가 아무
 * 문장도 주지 않은 경우에만 쓰이고, 그때 화면이 아는 것은 "이 조작이 거절됐다"뿐이다.
 * 403 이 아니면 `null` 이라 호출부가 자기 갈래로 이어 간다.
 */
const SHOP_MAP_FORBIDDEN_TEXT = '이 가게는 여기서 바꿀 수 없습니다.'

function shopMapForbiddenText(error) {
  if (httpStatusOf(error) !== 403) return null
  return deliveryMenuErrorMessage(error, '') || SHOP_MAP_FORBIDDEN_TEXT
}

/**
 * `GET /shop-map/impact` 실패 → 사장님이 보는 **한 문장**.
 *
 * 403 은 "못 읽었다"가 아니라 "바꿀 수 없다"이므로 다른 문장을 쓴다. 나머지(500·네트워크 등)는
 * 서버 문장에 화면만 아는 사실(저장을 멈췄다)을 덧붙인 그대로다.
 */
export function shopMapImpactFailureText(error) {
  return (
    shopMapForbiddenText(error) ||
    shopMapImpactUnknownText(deliveryMenuErrorMessage(error, '이 변경의 파급을 확인하지 못했습니다.'))
  )
}

/**
 * `POST /shop-map` 실패 → 사장님이 보는 **한 문장**.
 *
 * 400 은 서버 문장이 다음 행동을 이미 담으므로(`이 샵은 이미 다른 매장에 걸려 있습니다` 등) 그대로
 * 올린다 (§16.57·§16.121). 403 만 갈래가 다르다.
 */
export function shopMapAssignFailureText(error) {
  return shopMapForbiddenText(error) || deliveryMenuErrorMessage(error, '매핑을 저장하지 못했습니다.')
}

/**
 * 값의 **보이지 않는 차이**를 드러낸다 (§16.169).
 *
 * 서버 비교는 바이트 단위이므로(§16.122) 후행 공백 하나, 전각 괄호 하나가 정당한 드리프트다.
 * 그런데 화면은 그것을 `치즈 스파게티 → 치즈 스파게티` 처럼 **같은 값 두 개**로 보여 준다 —
 * dev 실측에서 그런 행이 여럿이었다. 사장님은 왜 막혔는지 알 수 없고, 알 수 없으면 정본을 고를 수
 * 없다.
 *
 * 앞뒤 공백만 기호로 바꾼다. 가운데 공백은 정상적인 낱말 구분이라 건드리지 않는다 — 전부 바꾸면
 * 이번엔 읽을 수 없는 문자열이 된다. 전각·유니코드 차이는 글자 자체가 다르므로 그대로 보인다.
 */
export function deliveryMenuVisibleValue(text) {
  return String(text).replace(/^\s+|\s+$/g, (run) => '␣'.repeat(run.length))
}

const OPTION_MAPPING_STATUS = Object.freeze({
  CONNECTED: { text: '연결됨', type: 'success' },
  UNLINKED: { text: '미연결', type: 'info' },
  NEEDS_REVIEW: { text: '연결 확인 필요', type: 'warning' },
})

export function optionMappingStatus(status) {
  return OPTION_MAPPING_STATUS[status] || OPTION_MAPPING_STATUS.NEEDS_REVIEW
}

export function optionMappingReason(reason) {
  return (
    {
      SOURCE_CHANGED: '오더엔 옵션의 메뉴 또는 그룹이 바뀌었습니다. 연결을 다시 확인해 주세요.',
      MANUALLY_UNLINKED: '담당자가 연결을 해제했습니다. 자동 대응으로 되돌리지 않습니다.',
      NO_OBSERVATION: OPTION_MAPPING_TEXT.UNREAD,
      ITEMS_UNREAD: '배달앱 옵션 목록을 아직 읽지 못했습니다. 최신 정보를 가져온 뒤 다시 조회해 주세요.',
      ITEM_IDS_UNREAD:
        '수집한 옵션의 식별 정보가 없습니다. 메뉴를 수집하는 POS를 업데이트하고 배달앱 정보를 다시 읽어 주세요.',
      AMBIGUOUS: '대상을 하나로 구분할 수 없습니다. 메뉴와 그룹별 식별 정보를 비교해 주세요.',
      DUPLICATE_TARGET: '다른 오더엔 옵션에 수동 연결된 대상입니다. 기존 연결을 확인해 주세요.',
      NO_MATCH: '자동으로 찾은 연결 대상이 없습니다. 오른쪽 배달앱 옵션 목록에서 직접 확인해 주세요.',
      TARGET_MISSING: '기존 연결 대상을 최신 수집 목록에서 찾지 못했습니다. 삭제 여부와 최신 정보를 확인해 주세요.',
    }[reason] || '최신 연결 정보를 다시 확인해 주세요.'
  )
}
